import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/NoResultsIllustration.tsx
const NoResultsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "no-results.svg",
		alt: t("illustration.imageAlt.noResults")
	});
};

//#endregion
export { NoResultsIllustration };